// extracted by mini-css-extract-plugin
export var audioPlayer = "_o9-0";